import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchFavoriteEntities } from '../../actions/favoriteEntities';
import { Pagination } from '../../components/Pagination';
import { selectResults } from '../../selectors';
import { EGetFavoriteEntitiesStatus } from '../../types/results';

export const PaginationContainer = () => {
  const dispatch = useDispatch();
  const { favoriteEntities, hasMore, status } = useSelector(selectResults);
  const favoriteLength = favoriteEntities.length;
  const isLoading = status === EGetFavoriteEntitiesStatus.NextPageLoading;

  const handleClick = React.useCallback(() => {
    if (isLoading) {
      return;
    }

    dispatch(fetchFavoriteEntities({ offset: favoriteLength, next: true }));
  }, [dispatch, favoriteLength, isLoading]);

  if (!hasMore || !favoriteLength) {
    return null;
  }

  return <Pagination loading={isLoading} onClick={handleClick} />;
};
